import { useEffect, useState } from 'react';
import { checkIsLoungeAvailable, isLivestreamType } from '../sessionBroadcastUtils';

export const useLoungeWaitingRoom = (session, timeZone, timeToStartInMilliseconds, playerStarted) => {
    const [showLoungeWaitingRoom, setShowLoungeWaitingRoom] = useState(() => checkIsLoungeAvailable(session, timeZone));

    useEffect(() => {

        const isLivestream = isLivestreamType(session);
        if (timeToStartInMilliseconds <= 0 && !isLivestream) {
            setShowLoungeWaitingRoom(false);
        } else {
            setShowLoungeWaitingRoom(checkIsLoungeAvailable(session, timeZone));
        }
    }, [timeToStartInMilliseconds, session, timeZone]);

    return showLoungeWaitingRoom && !playerStarted;
};
